









import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { GetchannelSetting } from '../api/common/index';

@Component({
  components: {},
})
export default class Index extends Vue {
  configUrl = 'https://cdn-h.gongfudou.com/Epson/mall_logo.png';
  mounted() {
    GetchannelSetting().then(res => {
      this.configUrl = res.mallLogo;
    });
  }
  buy() {
    window.open('https://www.xyzoa.cn', '_blank');
  }
}
